import React, { Component } from 'react';
import { NavLink }          from 'react-router-dom';
import AuthService          from 'services/auth.service';
import AssistantService     from 'services/assistant.service';

export class DoctorList extends Component {
  render() {
    const selectDoctor = (id) => {
      AssistantService.selectDoctor(id).then(
        (data) => {
          window.location.replace('/eb/select_location');
        },
        (error) => {
          console.log(error.response);
          alert(error.response.statusText);

          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }

    const doctorCards = this.props.items.map((hash, index) => {
      return (
        <tr key={ hash.doc_id } className="doctor-list-card-row bg-white" value={ '' }>
          {/* Desktop View */}
            <td valign="top" className="d-none d-lg-table-cell py-6 px-4 border-danger"><b>{ hash.dr_name }</b></td>
            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">{ hash.clinic_name }</td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
              <NavLink end={ true } to={ '/eb/profile?view_doctor_id=' + hash.doc_id } className="text-danger fweight-500">
                View Profile
              </NavLink>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
              <div className="text-danger fweight-500 clickable clickable-hover" onClick={() => selectDoctor(hash.doc_id) }>Select Doctor</div>
            </td>

          {/* Mobile View */}
            <td colSpan="4" valign="top" className="d-table-cell d-lg-none font-size-7 py-6 px-6 border-danger">
              <p><b>{ hash.dr_name }</b></p>
              <p>{ hash.clinic_name }</p>

              <div className="d-flex justify-content-between">
                <NavLink end={ true } to={ '/eb/profile?view_doctor_id=' + hash.doc_id } className="text-danger fweight-500">
                  View Profile
                </NavLink>

                <div className="text-danger fweight-500 clickable clickable-hover" onClick={() => selectDoctor(hash.doc_id) }>Select Doctor</div>
              </div>
            </td>
        </tr>
      )
    });

    const emptyHolder   = <tr className="patient-card-row bg-white">
      <td colSpan="4" className="text-center font-size-7 fweight-500 py-4" style={{ borderRadius: "0.5em" }}>No doctors found</td>
    </tr>;

    const displayCards  = doctorCards.length > 0 ? doctorCards : emptyHolder;

    return (
      <table id="dashboard-cards-table" className="w-100">
        <thead className="d-none d-lg-table-header-group">
          <tr>
            {
              ['Doctor Name', 'Hospital/Clinic', 'View Profile', 'Select Doctor'].map((name, index) => {
                const padding = index > 0 ? 'pr-4' : 'px-4';
                return <th key={ 'table-header-' + name } className={ "font-size-7 fweight-500 " + padding }>{ name }</th>
              })
            }
          </tr>
        </thead>

        <tbody>
          { displayCards }
        </tbody>
      </table>
    )
  }
}